<template>
  <main class="main" role="main">
    <div class="page">
      <div class="inner">
        <div class="lnb">
          <ul>
            <li><p class="home"></p></li>
            <li><p>외식 경영 관리사</p></li>
            <li><p>교육 신청</p></li>
            <li><p>교육 신청</p></li>
          </ul>
        </div>
        <div class="page_ttl">
          <h1 class="h1">
            <span>외식 경영 관리사 교육 신청</span>
          </h1>
        </div>
        <div class="page_con">
          <div class="table detail">
            <div class="row head">
              <div class="cell">
                <p class="left">
                  <span class="board_ttl">{{ item.exam.titleName }}</span>
                </p>
              </div>
              <div class="cell fix240">
                <p class="date">
                  {{ $moment(item.exam.regDate).format('YYYY.MM.DD') }}
                </p>
              </div>
            </div>
            <div class="row">
              <div class="cell detail_con">
                <div class="editor">
                  <div v-html="item.exam.contents"></div>
                  <!--div 꼭 넣어주세요!-->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="page_btn">
          <button class="btn bo grey" @click="() => $router.go(-1)">
            이전으로
          </button>
          <button class="btn" @click="fnWrite">시험 신청하기</button>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: 'manager-exam-apply-view',
  data: function() {
    const examinationNo = Number(this.$route.query.examinationNo)
    return {
      examinationNo,
      item: {}
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    userData() {
      return this.$store.getters['user/getUserData']
    }
  },
  methods: {
    fetchData: async function() {
      const res = await this.$ManagerSvc.getMapExam({
        examinationNo: this.examinationNo
      })
      console.log('res', res)
      this.item = res.entity
    },
    fnWrite: async function() {
      if (this.$Util.isEmpty(this.userData)) {
        alert('회원인 경우에만 신청할 수 있습니다.')
        return
      }
      const res = await this.$ManagerSvc.getIntUserExamApply({
        examinationNo: this.examinationNo
      })
      if (res.entity > 0) {
        alert(
          '해당 회차 시험을 이미 신청하였습니다. \n접수 확인 페이지에서 접수 확인 해주세요.'
        )
        return
      }
      await this.$router.push({
        path: '/manager/exam/apply/write',
        query: { examinationNo: this.item.exam.examinationNo }
      })
    }
  }
}
</script>

<style scoped></style>
